var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{on:{"click":function($event){_vm.crossOut = !_vm.crossOut}}},[_c('p',{class:{'cross-out': _vm.crossOut}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }